// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"176721ea","479":"538bd126","485":"dd26c12b","531":"2f9c65c5","915":"3582ad3e","949":"fc8607e7"}[chunkId] + ".chunk.js";
};